/*
    It is important to remember what the point of a reducer is. The
    application's data should never be mutated directly. A function should be
    put in place that returns the next state by looking at the previous state
    and an action that describes how things should change. This is the job of a
    reducer.

    A reducer should be kept *pure*, meaning that their output should rely
    solely on the arguments passed to them with no side effects such as making
    an API call or mutating the arguments passed in. This is just to keep
    things simple. A function that relies only on the arguments passed to it to
    derive the next state will be easier to reason about and debug.

    This was explained well here: https://auth0.com/blog/secure-your-react-and-redux-app-with-jwt-authentication/
*/
// import reducers
// import some redux tools
import { combineReducers } from "redux";

import app from "./app.reducer";
import authentication from "./authentication.reducer";
import autocomplete from "./autocomplete.reducer";
import company from "./company.reducer";
import dashboard from "./dashboard.reducer";
import departments from "./departments.reducer";
import documents from "./documents.reducer";
import feedback from "./feedback.reducer";
import fields from "./fields.reducer";
import goals from "./goals.reducer";
import hashtags from "./hashtags.reducer";
import integrations from "./integrations.reducer";
import ip from "./ip.reducer";
import jobs from "./jobs.reducer";
import modals from "./modals.reducer";
import navigation from "./navigation.reducer";
import page from "./page.reducer";
import permissions from "./permissions.reducer";
import requests from "./requests.reducer";
import reviewCycles from "./reviewCycles.reducer";
import reviewTemplates from "./reviewTemplates.reducer";
import reviews from "./reviews.reducer";
import selections from "./selections.reducer";
import settings from "./settings.reducer";
import slideouts from "./slideouts.reducer";
import users from "./users.reducer";
import workflows from "./workflows.reducer";

const rootReducer = combineReducers({
	ip,
	app,
	jobs,
	page,
	users,
	goals,
	modals,
	fields,
	reviews,
	company,
	settings,
	requests,
	feedback,
	hashtags,
	slideouts,
	documents,
	workflows,
	selections,
	navigation,
	permissions,
	departments,
	autocomplete,
	integrations,
	reviewCycles,
	authentication,
	reviewTemplates,
	dashboard,
});

export default rootReducer;
